import { Box, Image, Text, VStack } from "@chakra-ui/react";
import { interpretBoldTags } from "../../../utils/processPaywallText";
import { HighlightValuePropType } from "../types";

export function HighlightValueProps({
  valueProps,
}: {
  valueProps: HighlightValuePropType[];
}) {
  return (
    <VStack gap="40px" px={6} width="100%">
      {valueProps.map((valueProp, i) => (
        <HighlightValueProp key={i} valueProp={valueProp} />
      ))}
    </VStack>
  );
}

function HighlightValueProp({
  valueProp,
}: {
  valueProp: HighlightValuePropType;
}) {
  const bodyHtml = interpretBoldTags(valueProp.body, 600, "inherit", "white");
  return (
    <VStack gap={0} width="100%" alignItems="center">
      <Box width="100%" mb="-24px" position="relative" zIndex={0}>
        <Image
          src={valueProp.image_url}
          width="100%"
          objectFit="cover"
          borderRadius="12px"
          alt={valueProp.title}
          sx={{
            maskImage: "linear-gradient(to bottom, black 50%, transparent 85%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 50%, transparent 85%)",
          }}
        />
      </Box>
      <VStack gap="10px" position="relative" zIndex={1} textAlign="center">
        <Text
          fontFamily="'Bricolage Grotesque', sans-serif"
          fontWeight={500}
          fontSize={{ base: "18px", md: "24px" }}
          lineHeight={{ base: "1.1", md: "1.2" }}
          color="white"
        >
          {valueProp.title}
        </Text>
        <Text
          fontSize={{ base: "14px", md: "16px" }}
          lineHeight={{ base: "1.4", md: "1.5" }}
          color="neutral.400"
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      </VStack>
    </VStack>
  );
}
